import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment as config } from '../../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import { from } from 'rxjs/observable/from';
import * as moment from 'moment';

const API = config.stats.url;

@Injectable()
export class StatsService {
  // options: any;

  constructor(private http: Http, private authHttp: AuthHttp) {}

  call(url: string, options = {}) {
    // // TODO remove test data
    // if (url.indexOf('fake') >= 0) {
    //   return from([
    //     [
    //       { date: '2020-09-05', value: 4, name: '' },
    //       { date: '2020-09-06', value: 3, name: '' },
    //       { date: '2020-09-07', value: 2.5, name: '' },
    //       { date: '2020-09-08', value: 1.3, name: '' },
    //       { date: '2020-09-09', value: 5, name: '' }
    //     ]
    //   ]);
    // }
    // if (url.indexOf('empty') >= 0) {
    //   return from([[]]);
    // }
    // if (url.indexOf('zero') >= 0) {
    //   return from([{ value: 0 }]);
    // }

    return this.authHttp
      .get(url, options)
      .map(response => response.json())
      .catch(this.handleError);
  }

  alertsCount(sessionid: string) {
    return `${API}/events/${sessionid}/alertsCount`;
  }

  alertsConfirmedCount(sessionid: string) {
    return `${API}/events/${sessionid}/alertsConfirmedCount`;
  }

  liveUsersHitsCount(sessionid: string) {
    return `${API}/events/${sessionid}/liveUsersHitsCount`;
  }

  liveUsersUniqueCount(sessionid: string) {
    return `${API}/events/${sessionid}/liveUsersUniqueCount`;
  }

  liveUsersDurationAvg(sessionid: string) {
    return `${API}/events/${sessionid}/liveUsersDurationAvg`;
  }

  questionsBeforeCount(sessionid: string) {
    return `${API}/events/${sessionid}/questionsBeforeCount`;
  }

  questionsLiveCount(sessionid: string) {
    return `${API}/events/${sessionid}/questionsLiveCount`;
  }

  questionsPublishedCount(sessionid: string) {
    return `${API}/events/${sessionid}/questionsPublishedCount`;
  }

  answersPublishedCount(sessionid: string) {
    return `${API}/events/${sessionid}/answersPublishedCount`;
  }

  questionsBeforeDayList(sessionid: string) {
    return `${API}/events/${sessionid}/questionsBeforeDayList`;
  }

  questionsLive5minsCountList(sessionid: string) {
    return `${API}/events/${sessionid}/questionsLive5minsCountList`;
  }

  // pageHits(sessionid: string) {
  //   return `${API}/events/${sessionid}/pageHits`;
  // }

  transcriptHitsCount(sessionid: string) {
    return `${API}/events/${sessionid}/transcriptHitsCount`;
  }

  transcriptUniqueCount(sessionid: string) {
    return `${API}/events/${sessionid}/transcriptUniqueCount`;
  }

  transcriptTodayHitsCount(sessionid: string) {
    return `${API}/events/${sessionid}/transcriptTodayHitsCount`;
  }

  transcriptTodayUniqueCount(sessionid: string) {
    return `${API}/events/${sessionid}/transcriptTodayUniqueCount`;
  }

  transcriptDaysHitsList(sessionid: string) {
    return `${API}/events/${sessionid}/transcriptDaysHitsList`;
  }

  transcriptDaysUniqueList(sessionid: string) {
    return `${API}/events/${sessionid}/transcriptDaysUniqueList`;
  }

  sessionparam1List(sessionid: string) {
    return `${API}/events/${sessionid}/sessionparam1List`;
  }

  downloadCount(sessionid: string) {
    return `${API}/events/${sessionid}/downloadCount`;
  }

  downloadDailyCountList(sessionid: string) {
    return `${API}/events/${sessionid}/downloadDailyCountList`;
  }

  beforeliveHitsCount(sessionid: string) {
    return `${API}/events/${sessionid}/beforeliveHitsCount`;
  }

  beforeliveUniqueCount(sessionid: string) {
    return `${API}/events/${sessionid}/beforeliveUniqueCount`;
  }

  beforeliveDaysHitsList(sessionid: string) {
    return `${API}/events/${sessionid}/beforeliveDaysHitsList`;
  }

  beforeliveDaysUniqueList(sessionid: string) {
    return `${API}/events/${sessionid}/beforeliveDaysUniqueList`;
  }

  beforelive30minsHitsList(sessionid: string) {
    return `${API}/events/${sessionid}/beforelive30minsHitsList`;
  }

  beforelive30minsUniqueList(sessionid: string) {
    return `${API}/events/${sessionid}/beforelive30minsUniqueList`;
  }

  timeStarted(sessionid: string) {
    return `${API}/events/${sessionid}/timeStarted`;
  }

  timeStopped(sessionid: string) {
    return `${API}/events/${sessionid}/timeStopped`;
  }

  // fake(sessionid: string) {
  //   return `fake/${sessionid}`;
  // }

  // empty(sessionid: string) {
  //   return `empty/${sessionid}`;
  // }

  // zero(sessionid: string) {
  //   return `zero/${sessionid}`;
  // }

  handleError(error: any) {
    const errorMsg = error._body
      ? (JSON.parse(error._body) || {}).message
      : 'Yikes! There was was a problem with our stats service';
    return Observable.throw(errorMsg);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/stats/stats.service.ts